/** An object of border-radius keys and px values (strings and numbers) */
export const borderRadius = {
    zero: '0px',
    s: '2px',
    m: '4px',
    l: '8px',
    circle: '999px',
};
